import React, { Component } from "react";
import { Auth, Hub, OAuth } from "aws-amplify";
import { BrowserRouter as Router, Route, Redirect } from "react-router-dom";
import { Provider } from "react-redux";
import configureStore from "./service/store/configureStore.js";
import { CONSTANTES } from "./web/utils/Constantes";
import { CONSTANTES as constantesActions } from "./service/actions";
import iniciarConfiguracionAPI from "./service/commos/amplify";
import appRoutes from "./web/routes/App";
import Utils from "./web/utils/Validate";
const store = configureStore();
store.dispatch(constantesActions(false));
iniciarConfiguracionAPI();
class App extends Component {
  state = { validado: false };

  async componentWillMount() {
    //iniciarConfiguracionAPI();

    if (localStorage.getItem("loginFederate") !== "true") {
      try {
        const user = await Auth.currentAuthenticatedUser();
        console.log(user);
        this.setState({ validado: true });
      } catch (e) {
        console.log(e);
        const par = this.getUrlParams()["error_description"];
        if (par && par.includes("REINTENTAR")) {
          const customProvider = process.env.REACT_APP_OAUTH_PROVIDER;
          await Auth.federatedSignIn({ provider: customProvider });
          this.setState({ validado: true });
        } else {
          localStorage.setItem("login", false);
          this.setState({ validado: true });
        }
      }
    } else {
      this.setState({ validado: true });
    }
  }

  getUrlParams() {
    let query = window.location.search.substring(1);
    let params = query.split("&");
    let data = {};
    params.map(
      (param) =>
        param &&
        Object.assign(data, {
          [param.split("=")[0]]: decodeURIComponent(param.split("=")[1]),
        })
    );
    return data;
  }

  PrivateRoute = ({ componente: Component, ...rest }) => {
    console.log(
      "value login -->",
      localStorage.getItem("login"),
      localStorage.getItem("login") === "true"
    );
    return (
      <Route
        {...rest}
        render={(props) =>
          localStorage.getItem("login") === "true" &&
          Utils.validarPermisosXPath(rest.path) ? (
            <Component {...props} />
          ) : (
            <Redirect to={CONSTANTES.RUTA.login} />
          )
        }
      />
    );
  };

  render() {
    const PrivateRoute = this.PrivateRoute;
    return this.state.validado ? (
      <Provider store={store}>
        <Router basename={CONSTANTES.RUTA.basename}>
          <Route
            exact
            path={CONSTANTES.RUTA.path}
            render={() => <Redirect to={CONSTANTES.RUTA.login} />}
          ></Route>
          {appRoutes.map((prop, key) => {
            if (prop.redirect) {
              return <Redirect from={prop.path} to={prop.pathTo} key={key} />;
            } else {
              if (prop.access == "public")
                return (
                  <Route
                    path={prop.path}
                    component={prop.component}
                    key={key}
                  />
                );
              else
                return (
                  <PrivateRoute
                    path={prop.path}
                    componente={prop.component}
                    key={key}
                  />
                );
            }
          })}
        </Router>
      </Provider>
    ) : null;
  }
}
export default App;
